import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Typography,

} from "@material-ui/core";
import useStyles from '../styles/styles';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {base16AteliersulphurpoolLight} from 'react-syntax-highlighter/dist/esm/styles/prism';


const DNPPostingInstructions = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [codeTab, setCodeTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleCodeTab = (event, newValue) => {
        setCodeTab(newValue);
    };

    const sourceKeyUrl = (new URL(window.location)).searchParams.get("sourceKey");

    const sourceKeySet = sourceKeyUrl ? true : false;

    const sourceKey = sourceKeySet ? sourceKeyUrl : 'XXXXXXXX-XYXX-XXXX-XXXX-XXXXXXXXXXXX';

    function TabPanel(props) {
        const { children, value, value2, index, ...other } = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }
    function TabPanel2(props) {
        const {children, value, index, ...other} = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }

    return (
        <>
            <Typography variant="h2" gutterBottom>
                DNP Posting Instructions
            </Typography>
            <Typography variant="body1">
                <p>
                    Acquire Interactive provides their customers with a DNP API that allows affiliates to post lead details into their
                    system for advisement on positing into the Loan API to search for loan products.  To achieve this you
                    will need to post a JSON payload into our REST endpoint.
                </p>

            </Typography>

            <Paper className={`${classes.paper} ${classes.autoWidth}`}>
                <Table className={`${classes.table} ${classes.marginAuto}`}  size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Endpoint</TableCell>
                            <TableCell variant="head">Address</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Test</TableCell>
                            <TableCell>https://test-api.acquireinteractive.com/loan/dnp</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Production</TableCell>
                            <TableCell>https://api.acquireinteractive.com/loan/dnp</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="body1">
                <p>
                    The API is authenticated using <a href={"https://www.httpwatch.com/httpgallery/authentication/"}>HTTP Basic Authentication</a> over TLS.
                    Your account manager will provide you with a username and password combination for both the test and prod environments.
                    This authentication is identical to the credentials you were issued for the Loan API.

                </p>
                <p>
                    Example: username=david, password=strongpassword -- this combination would yield an authorization header as follows: "Authorization: Basic ZGF2aWQ6c3Ryb25ncGFzc3dvcmQ=".
                    Examples of how to include this header can be seen below in the code "Code Samples".
                </p>
                {sourceKeySet ? (
                    <p> The JSON payload will also include a "Source Key" that identified the source of your leads and ensures you are paid for ACCEPTED leads, your source key is "{sourceKey}".</p>
                ) : null}


            </Typography>

            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Field&nbsp;Name</TableCell>
                            <TableCell variant="head">Data&nbsp;Type</TableCell>
                            <TableCell variant="head">Required</TableCell>
                            <TableCell variant="head">Example</TableCell>
                            <TableCell variant="head">Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>source_key</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{sourceKey}</TableCell>
                            <TableCell>Required, the traffic source identifier provided by Acquire
                                Interactive</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>minimum_price</TableCell>
                            <TableCell>Decimal</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>50.10</TableCell>
                            <TableCell>Required, the minimum pay amount you are willing to receive for the lead<br/>Must be a
                                number great than or equal to zero. Only numbers and a single period are accepted.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code1</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>100</TableCell>
                            <TableCell>The traffic source (affiliate, organic, google, bing, etc.).<br />
                                The value may be coded, ie. you may use any value to represent 'google' such as '100' or 'kdjf' but keep it consistent.<br />
                                Values should not be unique - you can track your unique internal identifier within the 'source_lead_id' field.<br />
                                Maximum number of characters accepted is 32.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>ssn</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No&#x2a;</TableCell>
                            <TableCell>979128875</TableCell>
                            <TableCell>
                                Required, send only the 9 significant numbers that make up the customers Social Security Number.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>primary_email</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No&#x2a;</TableCell>
                            <TableCell>joe.b.doe@acquireinteractive.com</TableCell>
                            <TableCell>Required, the customers valid, well formed email address, maximum length is 128
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>home_phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No&#x2a;</TableCell>
                            <TableCell>5123486640</TableCell>
                            <TableCell>
                                A valid home_phone or mobile_phone for the customer is required. Both can be
                                provided.<br/>
                                Send only the 10 significant numbers that make up the phone number.</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="body1">
                <p>
                    &#x2a;At least one of the following lead details are required (ssn, primary email, home phone).  If multiple are sent then
                    only one is used. The first one in the following order of precedence is used: ssn, primary email, home phone.
                </p>
                <p>
                    Upon success you will receive a json response with a status of "DO_PRESENT" or "DO_NOT_PRESENT".
                </p>
                <p>
                    For testing, you can use ssn 999-99-9998 for a "DO_PRESENT" response and 999-99-9997 for a "DO_NOT_PRESENT" response.
                    All other requests will render a dynamic response based on the data in our test system.
                </p>

            </Typography>

            <Typography variant="h4" align="left">
                JSON Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                    centered
                    value={value}>
                    <Tab label="Input"/>
                    <Tab label="Do Present"/>
                    <Tab label="Do Not Present"/>
                    <Tab label="Error"/>
                </Tabs>



                <TabPanel2 value={value} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "source_key": "` + sourceKey + `",
    "minimum_price": 80.50,
    "source_sub_code_1": "100",
    "home_phone": "2073708323",
    "primary_email": "joe.b.doe@acquireinteractive.com",
    "ssn": "999999998"
}
                            `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "request_id": "4226b411-d1f3-423d-8b2a-1459a18ee0a0",
    "request_received": "2021-01-13T13:21:45.810Z",
    "response_rendered": "2021-01-13T13:21:49.695Z",
    "response_time": 3.885,
    "status": "DO_PRESENT",
    "messages": null,
    "validation_errors": null
}                          `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={2}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "request_id": "e7911693-60e7-4445-b998-9843082fd7d9",
    "request_received": "2021-01-13T14:14:50.313Z",
    "response_rendered": "2021-01-13T14:14:50.346Z",
    "response_time": 0.033,
    "status": "DO_NOT_PRESENT",
    "messages": null,
    "validation_errors": null
}                          `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={3}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "request_id": "599c7584-eaf9-44ee-965d-dafbc86dbd39",
    "request_received": "2021-01-13T14:15:19.189Z",
    "response_rendered": "2021-01-13T14:15:19.199Z",
    "response_time": 0.01,
    "status": "ERROR",
    "messages": null,
    "validation_errors": {
        "api": [
            "Must specify one of ssn, home_phone or primary_email."
        ]
    }
}                          `}
                    </SyntaxHighlighter>
                </TabPanel2>
            </Paper>
            <Typography variant="h4" align="left">
                Code Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={codeTab}
                    onChange={handleCodeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="PHP"/>
                    <Tab label="Node"/>
                    <Tab label="Java"/>
                    <Tab label="C#"/>
                    <Tab label="Curl"/>
                    <Tab label="Python"/>
                </Tabs>

                <TabPanel value={codeTab} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
    CURLOPT_URL => "https://test-api.acquireinteractive.com/loan/dnp",
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => "",
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => false,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => "POST",
    CURLOPT_POSTFIELDS => <<<EOT
    {
      "source_key": "` + sourceKey + `",
      "minimum_price": 80.50,
      "source_sub_code_1": "100",
      "home_phone": "5123486640",
      "primary_email": "joe.b.doe@acquireinteractive.com",
      "ssn": "200304000"
    }
EOT
    ,CURLOPT_HTTPHEADER => array(
        "Content-Type: application/json",
        "Authorization: Basic dGVzdDp0ZXN0"
    ),
));

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
    echo "cURL Error #:" . $err;
} else {
    echo $response;
} ?>
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {`
var postData =  \`{
 "source_key": "${sourceKey}",
    "minimum_price": 80.50,
    "source_sub_code_1": "100",
    "home_phone": "5123486640",
    "primary_email": "joe.b.doe@acquireinteractive.com",
    "ssn": "200304000"
}\`;

var https = require('https');

var options = {
    'host': 'test-api.acquireinteractive.com',
    'method': 'POST',
    'path': '/loan/dnp',
    'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Basic dGVzdDp0ZXN0',
        'Content-Length': postData.length
    }
};

var req = https.request(options, function (res) {
    var chunks = [];

    res.on("data", function (chunk) {
        chunks.push(chunk);
    });

    res.on("end", function (chunk) {
        var body = Buffer.concat(chunks);
        console.log(body.toString());
    });

    res.on("error", function (error) {
        console.error(error);
    });
});

req.write(postData);

req.end();
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={2}>
                    <SyntaxHighlighter language="java" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information, so that a response is displayed and received.
* In order to execute the code, create a command line app and place the code in the Main() method and run the application.
*/ 
try {
    URL a = new URL("https://test-api.acquireinteractive.com/loan/dnp");

    HttpURLConnection urlCon = (HttpURLConnection) a.openConnection();

    urlCon.setRequestMethod("POST");

    urlCon.setRequestProperty("Content-Type", "application/json");

    urlCon.setRequestProperty("Authorization", "Basic dGVzdDp0ZXN0");

    urlCon.setDoOutput(true);

    String json = "{\\"source_key\\": \\"${sourceKey}\\"," +
                    "\\"minimum_price\\": 80.50," +
                    "\\"source_sub_code_1\\": \\"100\\"," +
                    "\\"home_phone\\": \\"5123486640\\"," +
                    "\\"primary_email\\": \\"joe.b.doe@acquireinteractive.com\\"," +
                    "\\"ssn\\": \\"200304000\\"}";

    try (OutputStream os = urlCon.getOutputStream()) {
        byte[] input = json.getBytes("utf-8");
        os.write(input, 0, input.length);
    }

    if (urlCon.getResponseCode() < HttpURLConnection.HTTP_BAD_REQUEST) {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getInputStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    else {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getErrorStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    }
catch (MalformedURLException e) {
            e.printStackTrace();
        }
catch (IOException e) {
            e.printStackTrace();
}`}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={3}>
                    <SyntaxHighlighter language="c#" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information, so that a response is displayed and received.
* In order to execute the code, create a blank console application and place the code in the Main() method and run the application.
*/ 
Console.WriteLine("\\nCreating Request....");
HttpWebRequest httpWebRequest = (HttpWebRequest)WebRequest.Create("https://test-api.acquireinteractive.com/loan/dnp");
httpWebRequest.ContentType = "application/json";
httpWebRequest.Method = "POST";
httpWebRequest.Headers.Add("Authorization", "Basic dGVzdDp0ZXN0");

using (var streamWriter = new StreamWriter(httpWebRequest.GetRequestStream()))
{
    string json = "{\\"source_key\\": \\"${sourceKey}\\"," +
                    "\\"minimum_price\\": 80.50," +
                    "\\"source_sub_code_1\\": \\"100\\"," +
                    "\\"home_phone\\": \\"5123486640\\"," +
                    "\\"primary_email\\": \\"joe.b.doe@acquireinteractive.com\\"," +
                    "\\"ssn\\": \\"200304000\\","}";
                                  
    streamWriter.Write(json);

}
Console.WriteLine("\\nRequest Created....");
Console.WriteLine("\\nSending Request....");

try
{
    var httpResponse = (HttpWebResponse)httpWebRequest.GetResponse();

    using (var streamReader = new StreamReader(httpResponse.GetResponseStream()))
    {
        var result = streamReader.ReadToEnd();
        Console.WriteLine("\\nResponse received: " + result);
        Console.ReadLine();
    }
}
catch (WebException e)
{
    using (WebResponse response = e.Response)
    {
        using (Stream data = response.GetResponseStream())
        {
            StreamReader sr = new StreamReader(data);
            Console.WriteLine("\\nErred Response received: " + sr.ReadToEnd());
            Console.ReadLine();
        }
    }
}
   `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={4}>
                    <SyntaxHighlighter language="bash" style={base16AteliersulphurpoolLight}>
                        {`
curl --location --request POST "https://test-api.acquireinteractive.com/loan/dnp" \\
    --header "Content-Type: application/json" \\
    --header "Authorization: Basic dGVzdDp0ZXN0" \\
    --data "{
    \\"source_key\\": \\"` + sourceKey + `\\",
    \\"minimum_price\\": 80.50,
    \\"source_sub_code_1\\": \\"100\\", 
    \\"home_phone\\": \\"5123486640\\",
    \\"primary_email\\": \\"joe.b.doe@acquireinteractive.com\\",
    \\"ssn\\": \\"200304000\\"
}"
                            `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={5}>
                    <SyntaxHighlighter language="python" style={base16AteliersulphurpoolLight}>
                        {`
import requests

url = "https://test-api.acquireinteractive.com/lender/feedback"
data = {'source_key':  '${sourceKey}',
        'minimum_price': 80.50,
        'source_sub_code_1': '100',
        'home_phone': '5123486640',
        'primary_email': 'joe.b.doe@acquireinteractive.com',
        'ssn': 200304000}
            
headers = {'Content-Type': 'application/json', 'Authorization': 'Basic dGVzdDp0ZXN0'}
try:
    r = requests.post(url, data=data, headers=headers)
    r.raise_for_status()
    print(r.text)
except requests.exceptions.HTTPError as errh:
    print ("Http Error:",errh)
except requests.exceptions.ConnectionError as errc:
    print ("Error Connecting:",errc)
except requests.exceptions.Timeout as errt:
    print ("Timeout Error:",errt)
except requests.exceptions.RequestException as err:
    print ("Oops: Something Else",err)
                            `}
                    </SyntaxHighlighter>
                </TabPanel>
            </Paper>

        </>
    )
}

export default DNPPostingInstructions